import { useCallback, useEffect, useState } from 'react';

export const BROCHURE_SUPPRESSION_KEY = 'kuesb.brochure.hiddenKstDate';
const HOME_PATHS = ['/', '/homeApp', '/main'];
const koreanDateFormatter = new Intl.DateTimeFormat('en', {
  timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit',
});

export function getKoreanDateKey(now = new Date()) {
  const parts = koreanDateFormatter.formatToParts(now);
  return ['year', 'month', 'day'].map(type => parts.find(part => part.type === type).value).join('-');
}

export function isBrochureSuppressed(now = new Date()) {
  try {
    return window.localStorage.getItem(BROCHURE_SUPPRESSION_KEY) === getKoreanDateKey(now);
  } catch {
    return false;
  }
}

export function suppressBrochureForToday(now = new Date()) {
  try {
    window.localStorage.setItem(BROCHURE_SUPPRESSION_KEY, getKoreanDateKey(now));
    return true;
  } catch {
    return false;
  }
}

export function useBrochureModal(pathname) {
  const [isBrochureModalOpen, setIsBrochureModalOpen] = useState(false);

  useEffect(() => {
    if (HOME_PATHS.includes(pathname) && !isBrochureSuppressed()) {
      setIsBrochureModalOpen(true);
    }
  }, [pathname]);

  // Manual opening intentionally ignores the automatic-popup preference.
  const openBrochureModal = useCallback(() => setIsBrochureModalOpen(true), []);
  const closeBrochureModal = useCallback(() => setIsBrochureModalOpen(false), []);
  const hideBrochureForToday = useCallback(() => {
    suppressBrochureForToday();
    setIsBrochureModalOpen(false);
  }, []);

  return { isBrochureModalOpen, openBrochureModal, closeBrochureModal, hideBrochureForToday };
}
